import { render, staticRenderFns } from "./ImportExportConfigurations.vue?vue&type=template&id=c9fafc6c"
import script from "./ImportExportConfigurations.vue?vue&type=script&lang=js"
export * from "./ImportExportConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports